import React from 'react'
import PropTypes from 'prop-types'
import BEM from '@iui-kit/utils/bem'
import styles from './Input.css'

const bem = new BEM(styles)

const Input = ({ onChange, onBlur, placeholder, valid, size, className, ...other }) => (
  <input
    {...other}
    className={bem
      .b('input')
      .m(`width-${size}`)
      .mix(className)
      .m('invalid', !valid)
      .show()}
    placeholder={placeholder}
    onChange={onChange}
    onBlur={onBlur}
  />
)

Input.propTypes = {
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  valid: PropTypes.bool,
  size: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string
}

Input.defaultProps = {
  valid: true,
  size: '',
  placeholder: '',
  className: ''
}

export default Input
